<div class="navigation-root">
  <mat-toolbar class="header">
    @if (isMobile) {
      <button mat-icon-button (click)="toggelSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    }

    <div class="flex">{{ "title" | transloco }}</div>

    <button (click)="logout()" mat-icon-button>
      <mat-icon>logout</mat-icon>
    </button>
  </mat-toolbar>

  <mat-sidenav-container class="flex">
    <mat-sidenav [(opened)]="sidenav" [mode]="isMobile ? 'over' : 'side'">
      <mat-nav-list class="padding">
        <a class="row-gap-small" mat-list-item routerLink="customer">
          <div class="row-gap-small">
            <mat-icon>home</mat-icon>
            <div>{{ "customer.title" | transloco }}</div>
          </div>
        </a>

        <a mat-list-item routerLink="locations">
          <div class="row-gap-small">
            <mat-icon>location_on</mat-icon>
            <div>{{ "location.title" | transloco }}</div>
          </div>
        </a>

        <a mat-list-item routerLink="categories">
          <div class="row-gap-small">
            <mat-icon>event_note</mat-icon>
            <div>{{ "category.title" | transloco }}</div>
          </div>
        </a>

        <a mat-list-item routerLink="employees">
          <div class="row-gap-small">
            <mat-icon>person</mat-icon>
            <div>{{ "employee.title" | transloco }}</div>
          </div>
        </a>

        <a mat-list-item routerLink="group-series">
          <div class="row-gap-small">
            <mat-icon>groups</mat-icon>
            <div>{{ "group_series.title" | transloco }}</div>
          </div>
        </a>

        <a mat-list-item routerLink="admins">
          <div class="row-gap-small">
            <mat-icon>admin_panel_settings</mat-icon>
            <div>{{ "admin.title" | transloco }}</div>
          </div>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet />
    </mat-sidenav-content>
  </mat-sidenav-container>

  @if (footerService.visibility) {
    <div class="footer">
      <button mat-flat-button (click)="footerService.saveFunction()">{{ "button.save" | transloco }}</button>
    </div>
  }
</div>
